<template>
	<div :class="[{'menu-divider-border': border, 'menu-divider-large': large, 'menu-divider-inset': inset}]" class="menu-divider"/>
</template>

<script>
export default {
	name: 'TMenuDivider',
	props: {
		large: Boolean,
		border: {
			type: Boolean,
			default: true,
		},
		inset: Boolean
	}
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/colors';
	.menu-divider {
		box-sizing: border-box;
		&.menu-divider-border {
			border-bottom: 1px solid get-color($border, 'default');
		}
		&.menu-divider-large {
			padding-top: 8px;
			margin-bottom: 8px;
		}
		&.menu-divider-inset {
			margin-left: 40px;
		}
	}
</style>
